var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var BaseIcon = function (_a) {
    var className = _a.className, _b = _a.viewBox, viewBox = _b === void 0 ? "0 0 1024 1024" : _b, children = _a.children, styles = _a.styles;
    return (_jsx("i", { className: className, style: __assign({ width: "1em", height: "1em" }, styles), children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: viewBox, style: {
                display: "block",
                width: "100%",
                height: "100%",
            }, children: children }) }));
};
export default BaseIcon;
